import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Form, Control, Errors, actions} from 'react-redux-form'
import {Row, Col, FormGroup, FormControl, ControlLabel, Button, Checkbox, Radio} from 'react-bootstrap'
import {validators} from "../../../../utils/validators"
import ErrorMessages from '../../login/error-messages'
import ConfirmPopup from '../../../common/confirm-popup'
import UserTitleSelector from '../../../common/form/user/user-title-selector'
import UserFirstNameInput from '../../../common/form/user/user-first-name-input'
import UserLastNameInput from '../../../common/form/user/user-last-name-input'
import ArrowButton from '../../../common/button-arrow'
import Can from "../../../common/guards/can";
import {history} from "../../../../store";
import {getUserBaseData, saveAdmin, updateAdmin, sendWelcomeEmail, deleteAdmin} from '../../../../actions/users'

class EditUserForm extends Component {
  state = {
    showWelcomePopup: false,
    showDeletePopup: false
  };

  componentWillMount() {
    if(!this.props.id){
      this.props.dispatch(getUserBaseData());
    }
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  toggleWelcomePopup = () => {
    this.setState({
      showWelcomePopup: !this.state.showWelcomePopup
    })
  };

  handleWelcomePopup = (result) => {
    const {dispatch, user, showWelcomePopupSave} = this.props;

    if(result){
      dispatch(sendWelcomeEmail(user.id))
    }

    if(showWelcomePopupSave){
      dispatch({type: 'WELCOME_EMAIL_SENT'});
      dispatch({type: 'CLEAR_EDIT_USER'});
      history.push('/admin/users');
    }

    this.toggleWelcomePopup();
  };

  toggleDeletePopup = () => {
    this.setState({
      showDeletePopup: !this.state.showDeletePopup
    })
  };

  handleDeletePopup = (result) => {
    const {dispatch, user} = this.props;

    if(result){
      dispatch(deleteAdmin(user.id))
        .then(history.push('/admin/users'));
    }

    this.toggleDeletePopup();
  };

  onSubmit = (payLoad) => {
    const {dispatch, user, showWelcomePopupSave} = this.props;

    if (user.id) {
      dispatch(actions.submitFields('deep.admin_user.edit', updateAdmin(this.props.user.id, payLoad)))
          .then(() => {
            dispatch(actions.reset('deep.admin_user.edit'));
            history.push('/admin/users');
          });
    } else {
      dispatch(actions.submitFields('deep.admin_user.edit', saveAdmin(payLoad)))
          .then(() => {
            dispatch(actions.reset('deep.admin_user.edit'));
          });
    }
  };

  render(){
    const {dispatch, user, edit, userGroups, showWelcomePopupSave, commsEmail, statuses, id, showDeletePopup, formValid} = this.props;
    const {user_group, user_status, showWelcomePopup} = this.state;

    return (
      <Form model="deep.admin_user.edit"
            validateOn="submit"
            className="user-edit-form"
            onSubmit={this.onSubmit}>
        <Errors className="errors" model="deep.admin_user.edit" component={ErrorMessages}/>
        <Row>
          <Col lg={6}>
            <UserTitleSelector/>

            <UserFirstNameInput/>

            <UserLastNameInput/>

            <FormGroup controlId="userGroup" validationState={user_group}>
              <ControlLabel>Usergroup*</ControlLabel>
              <Control.select model=".user_group_id"
                              validators={{required: validators.required(this.updateErrors, 'user_group')}}
                              component={FormControl}
                              componentClass="select">
                <option value="" disabled>Select group...</option>
                {
                  userGroups && userGroups.map(item => {
                    return (<option key={item.id} value={item.id}>{item.name}</option>)
                  })
                }
              </Control.select>

              <Errors
                show={{touched: true, focus: false}}
                className="errors"
                model=".user_group_id"
                messages={{required: 'This field is required'}}/>
            </FormGroup>
          </Col>

          <Col lg={6}>
            <ControlLabel>{/**/}Communication preferences*</ControlLabel>
            <br/>
            <Col lg={3}>
              <FormGroup>
                <Control.checkbox model=".comms_email" disabled component={Checkbox}>email</Control.checkbox>
              </FormGroup>
            </Col>
            <Col lg={9}>
              <FormGroup>
                <Control.text
                  model=".email"
                  type="email"
                  placeholder="Email"
                  disabled={!commsEmail}
                  component={FormControl}/>

                <Errors
                  show={{touched: true, focus: false}}
                  className="errors"
                  model=".email"/>
              </FormGroup>
            </Col>

            <FormGroup controlId="userStatus" validationState={user_status}>
              <ControlLabel>Status*</ControlLabel>
              <Control.select model=".status"
                              validators={{required: validators.required(this.updateErrors, 'user_status')}}
                              component={FormControl}
                              componentClass="select">
                <option value="" disabled>Select status...</option>
                {
                  statuses && Object.keys(statuses).map(item => {
                    return (<option key={item} value={item}>{statuses[item]}</option>)
                  })
                }
              </Control.select>

              <Errors
                show={{touched: true, focus: false}}
                className="errors"
                model=".status"
                messages={{required: 'This field is required'}}/>
            </FormGroup>

            <FormGroup controlId="userAccountLocked">
              <div>
                <ControlLabel>Account locked*</ControlLabel>
              </div>
              <Control.radio model=".account_locked"
                             value="true"
                             validators={{required: validators.required(this.updateErrors, 'account_locked')}}
                             component={Radio}>Yes</Control.radio>
              <Control.radio model=".account_locked"
                             value="false"
                             validators={{required: validators.required(this.updateErrors, 'account_locked')}}
                             component={Radio}>No</Control.radio>

              <Errors
                show={{touched: true}}
                className="errors"
                model=".account_locked"
                messages={{required: 'You must set account lock state.'}}/>
            </FormGroup>
          </Col>

        </Row>
        <Row>
          <Col md={6}>
            {
              !isNaN(this.props.id) && <Button block
                                            onClick={this.toggleWelcomePopup}
                                            className="red-ghost-btn">Generate welcome notification</Button>
            }
            {
              (showWelcomePopup || showWelcomePopupSave) &&
              <ConfirmPopup header="Send welcome email?"
                            cancelLabel={showWelcomePopupSave ? 'No' : 'Cancel'}
                            confirmLabel={showWelcomePopupSave ? 'Yes' : 'Confirm'}
                            onClose={this.handleWelcomePopup}>
                <p>{showWelcomePopupSave ? 'You have created a new user  - d' : 'D'}o
                  you want to generate the welcome email?</p>
              </ConfirmPopup>
            }
          </Col>
          <Col md={6}>
            <ArrowButton className="pull-right"
                         disabled={!formValid}>Save</ArrowButton>
            {
              !isNaN(id) &&
              <ArrowButton arrow={false}
                           submit={false}
                           color="grey"
                           className="pull-right"
                           permissions={{
                             action:       'destroy',
                             subjectClass: 'User'
                           }}
                           onClick={this.toggleDeletePopup}>Delete user</ArrowButton>
            }
            {
              showDeletePopup && (
              <ConfirmPopup header="Delete user?"
                            onClose={this.handleDeletePopup}>
                <p>Do you really want to delete this user?
                  This operation will redact all personal information on the user record?</p>
              </ConfirmPopup>)
            }
          </Col>
        </Row>
      </Form>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.users.user,
    statuses: state.users.editorInput.statuses,
    userGroups: state.users.editorInput['user-groups'],
    commsEmail: state.deep.admin_user.edit.comms_email,
    formValid: state.deep.forms.admin_user.edit.$form.valid,
    showWelcomePopupSave: state.users.showWelcomePopup
  };
};

export default connect(mapStateToProps)(EditUserForm);


// WEBPACK FOOTER //
// ./src/components/admin/users/edit/user-edit-form.jsx